import { ThunkAction } from "redux-thunk";
import { RootState } from "../reducer";
import { ActionType } from "../reducer/types";
import { removeLoggedInData } from "../../common/utils";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOG_OUT = "LOG_OUT";
export const SET_SESSION_TIMEOUT_ERROR = "SET_SESSION_TIMEOUT_ERROR";
export const setLoginSuccessFully = (
  data: any
): ThunkAction<void, RootState, unknown, ActionType> => async (dispatch) => {
  // console.log("Login Success");
  dispatch({
    type: LOGIN_SUCCESS,
    payload: data,
  });
};

export const logOutUser = (): ThunkAction<
  void,
  RootState,
  unknown,
  ActionType
> => async (dispatch) => {
  // console.log("Login Success");
  await removeLoggedInData();
  dispatch({
    type: LOG_OUT,
  });
};

export const setSessionTimeoutError = (
  value: any
): ThunkAction<void, RootState, unknown, ActionType> => async (dispatch) => {
  // console.log("Login Success");
  dispatch({
    type: SET_SESSION_TIMEOUT_ERROR,
    payload: value,
  });
};
